import React from 'react'

function WorldwideIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 9L19 9"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 4C8.25 7 8.25 17 11.25 20"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 4C15.75 7 15.75 17 12.75 20"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M5 15L19 15"
        stroke="#899CBD"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default WorldwideIcon